import { render, staticRenderFns } from "./score2-explain-popup.vue?vue&type=template&id=658c3d68&scoped=true&"
import script from "./score2-explain-popup.vue?vue&type=script&lang=js&"
export * from "./score2-explain-popup.vue?vue&type=script&lang=js&"
import style0 from "./score2-explain-popup.vue?vue&type=style&index=0&id=658c3d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658c3d68",
  null
  
)

export default component.exports